import { TypographyVariants } from "@faire/web/slate/Typography";
import { TextDecorator } from "@faire/web-api--source/indigofair/data/TextDecorator";
import { TextStyleType } from "@faire/web-api--source/indigofair/data/TextStyleType";

const DEFAULT_TYPOGRAPHY_VARIANT = "paragraphSansRegular";

export const getSlateTypographyVariant = (
  textStyleType: keyof typeof TextStyleType | undefined,
  textDecorators: Array<keyof typeof TextDecorator> | undefined
): TypographyVariants => {
  if (textStyleType === undefined) {
    return DEFAULT_TYPOGRAPHY_VARIANT;
  }
  const textDecorator = textDecorators?.includes(TextDecorator.EMPHASIS)
    ? TextDecorator.EMPHASIS
    : textDecorators?.[0];
  return textStyleToTypographyVariantMap[textStyleType][
    textDecorator ?? TextDecorator.TEXT_DECORATOR_UNKNOWN
  ];
};

const textStyleToTypographyVariantMap: Record<
  TextStyleType,
  Record<TextDecorator, TypographyVariants>
> = {
  [TextStyleType.LABEL]: {
    [TextDecorator.EMPHASIS]: "labelSansMedium",
    [TextDecorator.UNDERLINE]: "labelSansRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "labelSansRegular",
    [TextDecorator.STRIKE_THROUGH]: "labelSansRegular",
  },
  [TextStyleType.PARAGRAPH]: {
    [TextDecorator.EMPHASIS]: "paragraphSansMedium",
    [TextDecorator.UNDERLINE]: "paragraphSansRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "paragraphSansRegular",
    [TextDecorator.STRIKE_THROUGH]: "paragraphSansRegular",
  },
  [TextStyleType.SUBHEADING]: {
    [TextDecorator.EMPHASIS]: "subheadingSansMedium",
    [TextDecorator.UNDERLINE]: "subheadingSansRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "subheadingSansRegular",
    [TextDecorator.STRIKE_THROUGH]: "subheadingSansRegular",
  },
  [TextStyleType.SECTION_HEADER]: {
    [TextDecorator.EMPHASIS]: "sectionHeaderSansMedium",
    [TextDecorator.UNDERLINE]: "sectionHeaderSansMedium",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "sectionHeaderSansMedium",
    [TextDecorator.STRIKE_THROUGH]: "sectionHeaderSansMedium",
  },
  [TextStyleType.PAGE_HEADER]: {
    [TextDecorator.EMPHASIS]: "pageHeaderSerifRegular",
    [TextDecorator.UNDERLINE]: "pageHeaderSerifRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "pageHeaderSerifRegular",
    [TextDecorator.STRIKE_THROUGH]: "pageHeaderSerifRegular",
  },
  [TextStyleType.DISPLAY_S_SANS]: {
    [TextDecorator.EMPHASIS]: "displaySSansSemiBold",
    [TextDecorator.UNDERLINE]: "displaySSansRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "displaySSansRegular",
    [TextDecorator.STRIKE_THROUGH]: "displaySSansRegular",
  },
  [TextStyleType.DISPLAY_S_SERIF]: {
    [TextDecorator.EMPHASIS]: "displaySSerifRegular",
    [TextDecorator.UNDERLINE]: "displaySSerifRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "displaySSerifRegular",
    [TextDecorator.STRIKE_THROUGH]: "displaySSerifRegular",
  },
  [TextStyleType.DISPLAY_M]: {
    [TextDecorator.EMPHASIS]: "displayMSerifRegular",
    [TextDecorator.UNDERLINE]: "displayMSerifRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "displayMSerifRegular",
    [TextDecorator.STRIKE_THROUGH]: "displayMSerifRegular",
  },
  [TextStyleType.DISPLAY_L]: {
    [TextDecorator.EMPHASIS]: "displayLSerifRegular",
    [TextDecorator.UNDERLINE]: "displayLSerifRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "displayLSerifRegular",
    [TextDecorator.STRIKE_THROUGH]: "displayLSerifRegular",
  },
  [TextStyleType.DISPLAY_XL]: {
    [TextDecorator.EMPHASIS]: "displayXLSerifRegular",
    [TextDecorator.UNDERLINE]: "displayXLSerifRegular",
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: "displayXLSerifRegular",
    [TextDecorator.STRIKE_THROUGH]: "displayXLSerifRegular",
  },
  [TextStyleType.TEXT_STYLE_TYPE_UNKNOWN]: {
    [TextDecorator.EMPHASIS]: DEFAULT_TYPOGRAPHY_VARIANT,
    [TextDecorator.UNDERLINE]: DEFAULT_TYPOGRAPHY_VARIANT,
    [TextDecorator.TEXT_DECORATOR_UNKNOWN]: DEFAULT_TYPOGRAPHY_VARIANT,
    [TextDecorator.STRIKE_THROUGH]: DEFAULT_TYPOGRAPHY_VARIANT,
  },
};
